export default function ArrowSVG({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      width={14}
      height={14}
      viewBox="0 0 24 24"
      strokeWidth={3}
      stroke="#fafcff"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m19.5 8.25-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
